import Socket from "./Socket";
import Logger from "../../../../utils/Logger";
//import * as SocketConstants from "./Socket";
//import streamSaver from "streamsaver";
//streamSaver.mitm = window.location.protocol  + "//" + window.location.hostname + "/mitm.html?version=" + streamSaver.version.full


/**
 * Socket for download task
 */
export default class SocketDownload extends Socket {

    constructor(url) {
        super(url);
    }

    runInternal(httpRequest, resolve) {
        Logger.log("GET " + this.url);
        Logger.log("Mode : " + this.mode);
        /*if (this.mode === SocketConstants.MODE_FETCH_STREAM && !process.env.NODE_ENV) {
            const fileStream = streamSaver.createWriteStream("download" + Math.random());
            this.writer = fileStream.getWriter();
            this.controller = new window["AbortController"]();
            this.signal = this.controller.signal;

            const options = {
                method: "GET",
                // headers: new Headers({"Access-Control-Request-Method": "GET"}),
                signal : this.signal
            };

            fetch(this.url, options).then(res => {
                const reader = res.body.getReader();
                this.httpStatus  = res.status;
                const pump = () => reader.read()
                    .then(({ value, done }) => {
                        if (done) {
                            this.writer.close();
                            resolve();
                        } else {
                            if (value) {
                                this.volume += value.length;
                            }
                            this.writer.write(value)
                                .then(pump)
                                .catch((e) => {
                                    Logger.log(e);
                                    this.hasFailed = true;
                                    resolve();
                                });
                        }
                    }).catch(() => {
                        //this.writer.close();
                        resolve();
                    });

                pump().then(() => {
                    //resolve();
                });
            }).then(() => {

            }).catch(() => {
                this.hasFailed = true;
                resolve();
            });

        } else if (this.mode === SocketConstants.MODE_XML_HTTP_REQUEST) {*/
            httpRequest.open("GET", this.url, true);

            //httpRequest.setRequestHeader('Access-Control-Request-Method', 'GET');

            httpRequest.addEventListener("progress", (evt) => {
                this.volume = evt.loaded;
            }, false);
            httpRequest.addEventListener("load", () => {
                this.httpStatus  = this.httpRequest.status;
                resolve();
            }, false);
            httpRequest.addEventListener("error", () => {
                Logger.log("=> Socket error");
                this.httpStatus  = this.httpRequest.status;
                this.hasFailed = true;
                resolve();
            }, false);
            httpRequest.addEventListener("abort", () => {
                Logger.log("=> Stopping abort");
                resolve();
            }, false);
            httpRequest.send();
        //}
    }

}



// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/socket/SocketDownload.js